import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hrm-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {
  pageWiseStyle = '';
  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {  
      dialogRef.disableClose = true;    
     }

  ngOnInit(): void {
    this.setStylesBasedOnPage();
  }
  setStylesBasedOnPage() {
    if (this.data && this.data['fromPage'] !== '') {
      switch (this.data['fromPage']) {
        case 'fromEventSummeryScreen':
          this.pageWiseStyle = 'fromEventSummeryScreen'
          break;
        case 'fromUploadDocumentScreen':
          this.pageWiseStyle = 'fromUploadDocumentScreen'
          break;
        default:
          this.pageWiseStyle = '';
          break;
      }
    }
    
  }

  confirmDelete(){
    this.dialogRef.close(true);
  }

  close(){
    this.dialogRef.close(false);
  }

}
